define('ch_semantic_responsive',[], function () {
    let isOpen = false;
    let savedScrollY = 0;
    const mobileSidebar = document.getElementById('mobile-sidebar');
    const mobileSidebarMain = document.getElementById('mobile-sidebar-main');
    const mobileSidebarToggle = document.getElementById('js-sidebar-toggle');

    function showSidebar () {
        if (mobileSidebar) {
            if (!isOpen) {
                // Fixing the page wrapper collapses the document, which clamps the
                // scroll offset to 0. Save it and shift the wrapper up to compensate,
                // so the visible content doesn't jump while the sidebar is open.
                savedScrollY = window.scrollY;
            }
            mobileSidebar.style.width = '300px';
            mobileSidebarMain.style.marginLeft = '300px';
            mobileSidebarMain.style.position = 'fixed';
            mobileSidebarMain.style.top = -savedScrollY + 'px';
            isOpen = true;

            // The panel is hidden with width:0, which does not remove its controls from the
            // tab order or the accessibility tree. `inert` does both.
            mobileSidebar.removeAttribute('inert');

            if (mobileSidebarToggle) {
                mobileSidebarToggle.setAttribute('aria-expanded', 'true');
            }

            const firstControl = mobileSidebar.querySelector('a, button');
            if (firstControl) {
                firstControl.focus();
            }

            document.addEventListener('keydown', captureEscape);
            mobileSidebarMain.addEventListener('click', captureOutsideClick, true); // capture
        }
    };

    function hideSidebar () {
        if (mobileSidebar) {
            // Capture before anything mutates isOpen; the scroll restore below depends on it.
            const wasOpen = isOpen;

            // Move focus out before making the panel inert, or the browser drops it to <body>.
            if (wasOpen && mobileSidebar.contains(document.activeElement) && mobileSidebarToggle) {
                mobileSidebarToggle.focus();
            }

            mobileSidebar.style.width = '0';
            mobileSidebarMain.style.marginLeft = '0';
            mobileSidebarMain.style.position = 'relative';
            mobileSidebarMain.style.top = '';
            isOpen = false;

            mobileSidebar.setAttribute('inert', '');

            if (mobileSidebarToggle) {
                mobileSidebarToggle.setAttribute('aria-expanded', 'false');
            }

            document.removeEventListener('keydown', captureEscape);
            mobileSidebarMain.removeEventListener('click', captureOutsideClick, true);

            if (wasOpen) {
                // Back in normal flow the document regains its height; put the user
                // back where they were before the wrapper was fixed. Guarded so the
                // unconditional hideSidebar() calls from the modal code (which run
                // even when the sidebar is closed) can't scroll the page.
                window.scrollTo(0, savedScrollY);
            }
        }
    };

    function captureEscape (e) {
        if (e.key === 'Escape' && isOpen) {
            hideSidebar();
        }
    }


    function captureOutsideClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hideSidebar();
    }


    const toggleSidebar = function() {
        if (isOpen) {
            hideSidebar();
        } else {
            showSidebar();
        }
    }

    if (mobileSidebar) {
        mobileSidebar.querySelector('.js-close-btn').addEventListener('click', (e) => {
            e.preventDefault();
            hideSidebar();
        });

        // expand/collapse the "Browse By Category" subcategory lists
        mobileSidebar.addEventListener('click', (e) => {
            const toggle = e.target.closest('.js-subcategories-toggle');
            if (!toggle) {
                return;
            }

            e.preventDefault();
            const subcategoryList = document.getElementById(toggle.getAttribute('aria-controls'));
            if (!subcategoryList) {
                return;
            }

            const expand = subcategoryList.hidden;
            subcategoryList.hidden = !expand;
            toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');

            const icon = toggle.querySelector('.icon');
            if (icon) {
                icon.classList.toggle('plus', !expand);
                icon.classList.toggle('minus', expand);
            }
        });
    }

    if (mobileSidebarToggle) {
        mobileSidebarToggle.addEventListener('click', (e) => {
            e.preventDefault();
            toggleSidebar();
        });
    }

    // exposing these so users of the responsive lib can hide/show the dimmer on demand
    return {
        hideSidebar,
        showSidebar,
    };
});

